import { useQuery } from '@tanstack/react-query';
import { getHouseEmailAliasesHousesHouseIdAliasesGetOptions } from '@/client/@tanstack/react-query.gen';

export interface UseHouseEmailAliasesOptions {
	enabled?: boolean;
}

/**
 * Fetches all email aliases for a house so the UI can display
 * alternative ingest email addresses users can send documents to.
 */
export const useHouseEmailAliases = (houseId: number, options: UseHouseEmailAliasesOptions = {}) => {
	return useQuery({
		...getHouseEmailAliasesHousesHouseIdAliasesGetOptions({
			path: { house_id: houseId },
		}),
		enabled: options.enabled ?? true,
	});
};

export default useHouseEmailAliases;
